class NotificationWithCookies {
    constructor(props) {
        this.settings = {
            ...props,
            cookie: {
                name: props.selector.dataset.cookiename,
                ttl: this.calcCookieTTL(props.selector) // livetime of cookie
            },
            time: {
                tts: parseInt(props.selector.dataset.tts), // time til notification is shown to the user
                ttl: parseInt(props.selector.dataset.ttl), // time to live (displaying notification)
                ttsa: parseInt(props.selector.dataset.ttsa) // time to show again
            }
        }

        this.notify = this.settings.selector;

        if (!(this.cookie.get(document.cookie, this.settings.cookie.name).key === this.settings.cookie.name)) {
            this.cookie.set('true')
        }

        this.handleControls();
        this.showNotification(this.settings.time.tts);
    }

    /**
     * Disable Notification after TTL expired
     */
    setTTL = () => {
        if (
            this.cookie.get(document.cookie, this.settings.cookie.name).value !== 'false' &&
            !this.notify.querySelector('.notify-footer').classList.contains('show-action')
        ) {
            const icon = document.querySelector('.newsletter-icon')

            this.settings.selector.classList.remove('show')
            if(icon) icon.classList.remove('pulse')
            this.showNotification(this.settings.time.ttsa);
        }
    }

    /**
     * Show Notification and set TTL
     */
    showNotification = timing => {
        if (this.cookie.get(document.cookie, this.settings.cookie.name).value !== 'false') {
            setTimeout(() => {
                if(document.querySelector('.newsletter-icon')) {
                    document.querySelector('.newsletter-icon').classList.add('pulse')
                }
                this.settings.selector.classList.add('show')
                this.timeoutTTL = setTimeout(this.setTTL, this.settings.time.ttl);
            }, timing)
        }
    }

    /**
     * Calculates when the cookies should expire
     * @param {HTMLElement} selector
     * @returns {Date} when cookie should expire
     */
    calcCookieTTL = (selector) => {
        let date = new Date();
        date.setDate(date.getDate() + parseInt(selector.dataset.cookiettl))

        return date
    }

    /**
     * Inits Controls of widget
     */
    handleControls = () => {
        this.controls.showAction() // shows action elements of widget
        this.controls.hideAction() // hides action elements of widget
        this.controls.closeNotification() // close widget element and set cookie to false
    }

    /**
     * @desc All Widget controls
     */
    controls = {
        showAction: () => {
            let toggleAction = this.notify.querySelector('.toggle-action');
            if (toggleAction) {
                toggleAction.addEventListener('click', Event => this.widgetEvents.showActionControlsEvent(Event))
            }
        },
        hideAction: () => {
            let dismis = this.notify.querySelector('.dismis');
            if (dismis) {
                dismis.addEventListener('click', Event => this.widgetEvents.hideActionControlsEvent(Event))
            }
        },
        closeNotification: () => {
            let notifyClose = this.notify.querySelector('.notify-close');
            if (notifyClose) {
                notifyClose.addEventListener('click', Event => this.widgetEvents.closeNotificationEvent(Event))
            }
        }
    }

    /**
     * @desc All Widget events
     */
    widgetEvents = {
        showActionControlsEvent: (Event) => {
            Event.preventDefault();
            this.notify.querySelector('.notify-footer').classList.add('show-action')
            clearTimeout(this.timeoutTTL);
        },
        hideActionControlsEvent: (Event) => {
            Event.preventDefault();
            this.notify.querySelector('.notify-footer').classList.remove('show-action')
            this.showNotification()
        },
        closeNotificationEvent: (Event) => {
            Event.preventDefault();
            this.settings.selector.classList.remove('show')
            document.querySelector('.newsletter-icon').classList.remove('pulse')
            this.cookie.set('false')
        }
    }

    cookie = {
        /**
         * Write Widget Cookie
         * @param {string} value
         */
        set: value => {
            document.cookie = `${this.settings.cookie.name}=${value}; expires=${this.settings.cookie.ttl};"`;
        },

        /**
         * Receive cookie by Name
         * @param {string} c
         * @param {string} name
         * @returns {object} of cookie key and value
         */
        get: (c, name) => {
            let cookies = {};

            c.split(';').forEach(cookiePair => {
                cookiePair = cookiePair.split('=');

                let res = {
                    key: cookiePair[0].replaceAll(' ', ''),
                    value: cookiePair[1]
                }

                if (res.key === name) {
                    cookies = res;
                }
            })

            return cookies;
        }
    }
}

if(document.querySelector('#newsletter-notification')) {
    setTimeout(() => {
        new NotificationWithCookies({selector: document.querySelector('#newsletter-notification')})
    }, 500)
}
